import React, { useState } from 'react';
import './OtherProjects.css';
import blogsite from '../../Assets/projects/blogsite.png';
import donation from '../../Assets/projects/donate.png';
import camera from '../../Assets/projects/camera.png';
import panda from '../../Assets/projects/panda.png';
import gym from '../../Assets/projects/gym.png';
import education from '../../Assets/projects/education.png';
import football from '../../Assets/projects/football.png';
import player from '../../Assets/projects/player.png';
import healthy from '../../Assets/projects/healthy.png';
import news from '../../Assets/projects/news.png';
import { FiGithub } from 'react-icons/fi';
import { CarouselProvider } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import CarouselSlider from './CarouselSlider';
import styled from "styled-components";
import { BiLinkExternal } from 'react-icons/bi';

const OtherProjects = () => {

  // let data = [
  //     {
  //         id: "1",
  //         imgSrc: "https://helpx.adobe.com/content/dam/help/en/photoshop/using/convert-color-image-black-white/jcr_content/main-pars/before_and_after/image-before/Landscape-Color.jpg"
  //     },
  //     {
  //         id: "2",
  //         imgSrc: "https://www.freecodecamp.org/news/content/images/2022/09/jonatan-pie-3l3RwQdHRHg-unsplash.jpg"
  //     },
  //     {
  //         id: "3",
  //         imgSrc: "https://media.istockphoto.com/id/1220710621/photo/serpentine-river.jpg?s=612x612&w=0&k=20&c=OKlJMZoNYriDHgbVvZOLxbyEpjLM_cpqWLFXmVAeVBA="
  //     },
  //     {
  //         id: "4",
  //         imgSrc: "https://helpx.adobe.com/content/dam/help/en/photoshop/using/convert-color-image-black-white/jcr_content/main-pars/before_and_after/image-before/Landscape-Color.jpg"
  //     },
  //     {
  //         id: "5",
  //         imgSrc: "https://www.freecodecamp.org/news/content/images/2022/09/jonatan-pie-3l3RwQdHRHg-unsplash.jpg"
  //     },
  // ];
  // let manner = {
  //     // autoSliding: { interval: "2s" },
  //     style: {
  //         left: {
  //             margin: "0px 20px 0px 20px",
  //             padding: "0px 20px 0px 20px"
  //         },
  //         right: {
  //             margin: "0px 0px 0px 0px"
  //         }
  //     }
  // };
  // let buttonSetting = {
  //     placeOn: "bottom-beneath",
  //     //hoverEvent: true,
  //     style: {
  //         left: {
  //             margin: "0px 0px 0px 0px"
  //         },
  //         right: {
  //             margin: "0px 0px 0px 0px"
  //         }
  //     }
  // };
  // let itemsStyle = {
  //     width: "250px"
  // };

  //no of slide to be visible
  //     const [slideCount, setSlideCount] = useState(2);
  //     const [currentSlide, setCurrentSlide] = useState(0);

  //     const CarouselWrapper = styled.div`
  //   &.carousel-container {
  //     margin: 12px auto;
  //     max-width: 272px;
  //     filter: drop-shadow(0px 12px 30px rgba(50, 50, 50, 0.2));

  //     /* Total-width (including margin) + 1 additional margin */
  //     @media (min-width: 832px) {
  //       max-width: 704px;
  //     }

  //     @media (min-width: 1088px) {
  //       max-width: 960px;
  //     }

  //     @media (min-width: 1272px) {
  //       max-width: 1152px;
  //     }

  //     @media (min-width: 1504px) {
  //       max-width: 1344px;
  //     }
  //   }

  //   /* This class is found in Slide from pure-react-carousel */
  //   /* We need to override it to add space between slides */
  //   .carousel__inner-slide {
  //     /* width: 100% - margin */
  //     width: calc(100% - 16px);
  //     /* margin-left: margin/2 */
  //     /* margin is required to adjust positioning as the width is diminished*/
  //     margin-left: 8px;

  //     @media (min-width: 1272px) {
  //       width: calc(100% - 24px);
  //       margin-left: 12px;
  //     }

  //     @media (min-width: 1272px) {
  //       width: calc(100% - 32px);
  //       margin-left: 16px;
  //     }
  //   }
  // `;

  return (

    <div className='lg:mt-40'>
      <div className='text-3xl md:text-4xl flex mb-10'>
        <h3 className='md:numbered-heading-projects font-bold headline-style ml-2 md:ml-10 lg:ml-0'>Other projects I've done</h3>
        {/* <h3 className='numbered-heading-project font-bold headline-style'>Some Things I’ve Build</h3> */}
      </div>
      {/* Old Design version 1.0 */}


      {/* Large Screen */}
      {/* <div className=" w-full hidden md:inline-block" data-aos="fade-up">
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full flex gap-5 px-10'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box4"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Blogsite</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box5"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Influencer Products</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box6"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Panda</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div id="item2" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full flex gap-5 px-10'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box7"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Rise Turn Club</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React</p>
                </div>

              </div>
            </div>

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box8"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>News Portal</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React</p>
                </div>

              </div>
            </div>

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box9"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Healthy Diet</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div id="item3" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full flex gap-5 px-10'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box10"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>WatchBall</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box11"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Favyers</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Javascript</p>
                </div>

              </div>
            </div>

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box12"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Rise Turn</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div id="item4" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full flex gap-8 px-10'>
            <div className='w-4/12'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box13"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Donate</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div> */}


      <div className=" w-full hidden md:inline-block" data-aos="fade-up">
        <div id="item1" className="carousel-item w-full  mt-10">
          <div className='w-full grid grid-cols-2 lg:grid-cols-3 gap-5 px-10'>

            {/* 1 */}
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box14"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center justify-between mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex  items-center gap-3'>Coffee House
                  </p>

                  <div className='flex gap-2 text-xl mr-2'>
                    <a href="https://a-coffee-house.netlify.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>

                    <a href="https://github.com/Syeda-Aisha-Ahmad/Coffee-shop" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                  </div>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Javascript</p>
                </div>

              </div>
            </div>

            {/* 2 */}
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box15"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center justify-between mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex  items-center gap-3'>Panar Hotel
                  </p>

                  <div className='flex gap-2 text-xl mr-2'>
                    <a href="https://panar-hotel.netlify.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>

                    <a href="https://github.com/Syeda-Aisha-Ahmad/Panar-Hotel" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                  </div>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Javascript</p>
                </div>

              </div>
            </div>

            {/* 3 */}
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box4"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center justify-between mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex  items-center gap-3'>Blog Site
                  </p>

                  <div className='flex gap-2 text-xl mr-2'>
                    <a href="https://newblogsite.netlify.app" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>

                    <a href="https://github.com/Syeda-Aisha-Ahmad/blogsite" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                  </div>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Tailwind</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React Js</p>
                </div>

              </div>
            </div>

            {/* 4 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box5"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Influencer Products
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div> */}

            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box5"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center justify-between mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex  items-center gap-3'>Excursion
                  </p>

                  <div className='flex gap-2 text-xl mr-2'>
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>

                    <a href="https://github.com/Syeda-Aisha-Ahmad/excursion_client_repo" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                  </div>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Tailwind</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React Js</p>
                </div>

              </div>
            </div>

            {/* 5 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box6"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Panda
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div> */}

            {/* 6 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box5"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center justify-between mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex  items-center gap-3'>Excursion
                  </p>

                  <div className='flex gap-2 text-xl mr-2'>
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a>

                    <a href="https://github.com/Syeda-Aisha-Ahmad/riseTurn-club" target="_blank" rel="noreferrer" className='hover:text-sky-600'><FiGithub className='mr-3' /></a>
                  </div>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Tailwind</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React Js</p>
                </div>

              </div>
            </div> */}

            {/* 7 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box8"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>News Portal
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React</p>
                </div>

              </div>
            </div> */}

            {/* 8 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box9"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Healthy Diet
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div> */}

            {/* 9 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box10"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Watchball
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div> */}

            {/* 10 */}
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box11"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Favyers
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Javascript</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Dom</p>
                </div>

              </div>
            </div>

            {/* 11 */}
            {/* <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box12"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Rise Turn
                    <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div> */}

            {/* 12 */}
            <div className='w-full'>
              <div className='w-full'>
                <div className='container h-[200px] w-full'>
                  <div className="boxes box13"></div>
                </div>
                <div className='ml-3 md:mb-10'>
                  <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                    <p className='text-xl ml-1 font-semibold flex items-center gap-3'>Donate
                      <a href="https://excursion-e221c.web.app/" target="_blank" rel="noreferrer" className='hover:text-sky-600'><BiLinkExternal /></a></p>
                  </div>
                  <div className='flex items-center mt-3 gap-2'>
                    <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                    <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>


      {/* <div className="flex justify-center w-full py-2 gap-2 mt-5">
        <a href="#item1" className="btn btn-xs bg-sky-600 text-white border-none hover:bg-sky-800">1</a>
        <a href="#item2" className="btn btn-xs bg-sky-600 text-white border-none hover:bg-sky-800">2</a>
        <a href="#item3" className="btn btn-xs bg-sky-600 text-white border-none hover:bg-sky-800">3</a>
        <a href="#item4" className="btn btn-xs bg-sky-600 text-white border-none hover:bg-sky-800">4</a>
      </div> */}


      {/* Small Screen */}
      <div className="carousel w-screen md:hidden" data-aos="fade-up">
        <div id="item1" className="carousel-item w-full lg:h-[300px] mt-10">

          {/* 1 */}
          <div className='w-full'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box4"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Blogsite</p>
                </div>
                <div className='flex  items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* 2 */}
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box5"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Influencer Products</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* 3 */}
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='container h-[200px] w-full'>
              <div className="boxes box6"></div>
            </div>
            <div className='ml-3 md:mb-10'>
              <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                <p className='text-xl ml-1 font-semibold'>Panda</p>
              </div>
              <div className='flex items-center mt-3 gap-2'>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
              </div>

            </div>
          </div>
        </div>

        {/* 4 */}
        <div id="item2" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box7"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Rise Turn Club</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React</p>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* 5 */}
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='container h-[200px] w-full'>
              <div className="boxes box8"></div>
            </div>
            <div className='ml-3 md:mb-10'>
              <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                <p className='text-xl ml-1 font-semibold'>News Portal</p>
              </div>
              <div className='flex items-center mt-3 gap-2'>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>React</p>
              </div>

            </div>
          </div>
        </div>


        {/* 6 */}
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='container h-[200px] w-full'>
              <div className="boxes box9"></div>
            </div>
            <div className='ml-3 md:mb-10'>
              <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                <p className='text-xl ml-1 font-semibold'>Healthy Diet</p>
              </div>
              <div className='flex items-center mt-3 gap-2'>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
              </div>

            </div>
          </div>
        </div>

        {/* 7 */}
        <div id="item3" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='w-full'>
              <div className='container h-[200px] w-full'>
                <div className="boxes box10"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>WatchBall</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>


        {/* 8 */}
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='container h-[200px] w-full'>
              <div className="boxes box11"></div>
            </div>
            <div className='ml-3 md:mb-10'>
              <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                <p className='text-xl ml-1 font-semibold'>Favyers</p>
              </div>
              <div className='flex items-center mt-3 gap-2'>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Javascript</p>
              </div>

            </div>
          </div>
        </div>


        {/* 9 */}
        <div id="item1" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='container h-[200px] w-full'>
              <div className="boxes box12"></div>
            </div>
            <div className='ml-3 md:mb-10'>
              <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                <p className='text-xl ml-1 font-semibold'>Rise Turn</p>
              </div>
              <div className='flex items-center mt-3 gap-2'>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
              </div>

            </div>
          </div>
        </div>

        {/* 10 */}
        <div id="item4" className="carousel-item w-full h-[300px] lg:h-[280px] mt-10">
          <div className='w-full'>
            <div className='w-full'>
              <div className='container h-[200px]'>
                <div className="boxes box13"></div>
              </div>
              <div className='ml-3 md:mb-10'>
                <div className='flex items-center mt-16 md:mt-5 lg:mt-5 gap-20'>
                  <p className='text-xl ml-1 font-semibold'>Donate</p>
                </div>
                <div className='flex items-center mt-3 gap-2'>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Html</p>
                  <p className='text-sm mx-1 py-0  text-sky-600 font-semibold'>Css</p>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>

    </div >
  );


};

export default OtherProjects;